import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";



export const useIgmDashboard = (view, filters = {}) => {
  const dispatch = useDispatch();
  const { authData, storeId } = useSelector((state) => state.loginSlice || {});
  const { addToast } = useToasts();
  

  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(async () => {
    if (!authData) return;

    setLoading(true);
    try {
      const params = new URLSearchParams({
        issue_type: view,
      });

      // Append filters only if they have a value
      if (filters.created_from) {
        params.append("created_from", filters.created_from);
      }
      if (filters.created_to) {
        params.append("created_to", filters.created_to);
      }
      if (filters.issue_level) {
        params.append("issue_level", filters.issue_level);
      }

      // Use the constructed URL
      const url = `${endpoint.GET_IGM_ANALYTICS}?${params.toString()}`;
      const result = await apiHandler({
        url,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        authToken: authData,
        dispatch,
        storeId,
      });
      //console.log("Analytics Result:", result);
      if (result?.data?.success && result?.data?.data) {
        //console.log("Fetched Analytics Data:", result.data.data);
        setAnalytics(result.data.data);
      } else {
        //console.error("Failed to fetch analytics:", result?.data?.message);
        setAnalytics(null);
        addToast(result?.data?.message || "Failed to fetch analytics", {
          appearance: "error",
        });
      }
    } catch (err) {
      //console.error("Error fetching analytics:", err);
      setAnalytics(null);
      addToast("An unexpected error occurred", { appearance: "error" });
    } finally {
      setLoading(false);
    }
  }, [view, authData, dispatch, storeId, addToast,filters.created_from,
    filters.created_to,
    filters.issue_level,]);

  useEffect(() => {
    if (!authData) return;
    getData();
  }, [getData, authData,]);

  return { analytics, loading };
};
